import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, Logger } from '@ngrx/data';
import { HttpClient } from '@angular/common/http';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {InsolesModel} from '../../../api/model/insoles.model';
import {InsolesConverter} from '../../../api/model/insoles.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';

@Injectable()
export class InsolesDataService extends AbstractDataServiceV2<InsolesModel, InsolesConverter> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: CustomizeHttpUrlGenerator,
        logger: Logger,
        config: DefaultDataServiceConfig,
        converter: InsolesConverter) {
        super('Insoles', http, httpUrlGenerator, logger, config, converter);
    }
}
